import { useState, useRef } from "react";
window.modelViewerMessages = [];

import Viewer from "./../../blocks/3d-viewer/Components/Common/Viewer";

const FrontEnd = ({ attributes }) => {
    const [modelReader, setModelReader] = useState(null);
    function __(text, textdomain = "") {
        return text;
    }
    const viewerRef = useRef();
    window.modelViewerMessages.push({ attributes, viewerRef });
    if (attributes) {
        return <Viewer {...{ attributes, viewerRef, __, modelReader, setModelReader }} />;
    }
};

export default FrontEnd;